import React, { FC } from 'react';

interface IProps {
  title?: string;
  className?: string;
  children: React.ReactNode;
  secondaryText?: string;
}

export const SectionBase: FC<IProps> = ({ title, children, className, secondaryText }) => {
  return (
    <div
      className={`flex min-h-[100px] flex-col rounded-[10px] border bg-white px-5 pb-4 pl-[8px] pr-[8px] pt-4 shadow-lg min-[425px]:px-5  min-[1024px]:max-h-full ${
        className ?? ''
      }`}
      data-cy="section-base"
    >
      <div className="flex items-center gap-[20px]">
        {title && <h2 className="py-2 text-[26px] font-bold text-primary">{title}</h2>}
        {secondaryText && <p className="py-2 text-[16px] font-semibold text-primary">{secondaryText}</p>}
      </div>

      {children}
    </div>
  );
};
